module.exports = __webpack_public_path__ + "img/Sedan_Front_Side_Left_Transparent.31c92540.svg";